// Get API URL from environment variable or use default
// IMPORTANT: Use getApiUrl() at runtime, not API_URL constant, to ensure correct URL on mobile
import { getApiUrl } from '../../utils/apiUtils';
import { debugError } from '../../utils/debug';

// Export getApiUrl for use in other RunSchedule components
export { getApiUrl };

// Get the user's token for API requests (same pattern as ChatInterface)
export const getToken = async (user) => {
  try {
    // Get a proper JWT token if possible
    if (user && user.getToken) {
      // Try to get a JWT token from Clerk
      const token = await user.getToken();
      return token;
    } 
    // Use the user ID as a fallback for development/testing
    if (user && user.id) {
      return user.id;
    }
    throw new Error('No authentication token available');
  } catch (error) {
    debugError('Error getting token:', error);
    throw new Error('Authentication error: ' + error.message);
  }
};

// Timezone utility functions
export const getTimezoneOffset = () => {
  // Get user's timezone offset in minutes from UTC (positive for ahead of UTC)
  return new Date().getTimezoneOffset() * -1;
};

// Convert UTC timestamp to local time for display
export const toLocalTime = (utcTimestamp) => {
  // Ensure timestamp is treated as UTC by adding 'Z' suffix if not present
  const utcTimestampString = typeof utcTimestamp === 'string' 
    ? (utcTimestamp.endsWith('Z') ? utcTimestamp : utcTimestamp + 'Z')
    : utcTimestamp.toISOString();
  
  return new Date(utcTimestampString);
};

// Convert local time to UTC for sending to backend
export const toUTCTime = (localTimestamp) => {
  return new Date(localTimestamp).toISOString();
};

// Get relative date text for display
export const getRelativeDateText = (dateString) => {
  const inputDate = new Date(dateString);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  
  // Reset time to compare just dates
  const inputDateOnly = new Date(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate());
  const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const yesterdayOnly = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate());
  const tomorrowOnly = new Date(tomorrow.getFullYear(), tomorrow.getMonth(), tomorrow.getDate());
  
  if (inputDateOnly.getTime() === todayOnly.getTime()) {
    return 'Today';
  } else if (inputDateOnly.getTime() === yesterdayOnly.getTime()) {
    return 'Yesterday';
  } else if (inputDateOnly.getTime() === tomorrowOnly.getTime()) {
    return 'Tomorrow';
  } else {
    // Return day of week for other dates
    const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return dayNames[inputDate.getDay()];
  }
}; 